import React, {useCallback, useEffect, useState} from "react";
import {ElementoRMLSelezionabileRecord} from "@commons/mapping/ElementoRMLSelezionabileRecord";
import {DndProvider, DropTargetMonitor} from "react-dnd";
import {HTML5Backend} from "react-dnd-html5-backend";
import DropZone from "./DropZone";
import {ItemTypes} from "../../../../core/DnDItemTypes";
import {LoadingSpinner} from "../../../../components/comboBox/ComboBox";
import {TipoElementoRML} from "@commons/mapping/ElementoRMLRecord";
import {MutationError} from "../../../../core/editor";
import {useUpdateMutation} from "@commons/features/lavoratore/elemitiRMLSelezionati.api";
import {toastAsError} from "@utilities/toastAsError";

const AreaSelezioneElementiRML: React.FC<{
    data: ElementoRMLSelezionabileRecord[] | undefined,
    onApply?: () => void,
    onChange?: (elementi: ElementoRMLSelezionabileRecord[]) => void,
    isLoading?: boolean,
    children?: React.ReactNode;
    onResetFilter?: () => void,
}> = ({
          data, onApply, onChange, isLoading = false, children, onResetFilter,
      }) => {
    const [elementiSelezionabili, setElementiSelezionabili] = useState<ElementoRMLSelezionabileRecord[]>([]);
    const [elementiSelezionati, setElementiSelezionati] = useState<ElementoRMLSelezionabileRecord[]>([]);
    useEffect(() => {
        const newElenco: ElementoRMLSelezionabileRecord[] = [];
        if (data)
            for (const elemento of data) {
                newElenco.push(elemento);
            }
        setElementiSelezionabili(() => newElenco);
    }, [data]);

    const handleDrop = useCallback(
        (elemento: ElementoRMLSelezionabileRecord, monitor: DropTargetMonitor) => {
            /*console.log(elemento.descrizione);
            return {selected: true, elemento: elemento};*/
        },
        [],
    )

    useEffect(() => {
        if (onChange)
            onChange(elementiSelezionati);
    }, [elementiSelezionati, onChange])

    const divCardClass = 'overflow-hidden rounded-lg shadow-xl ring-1 ring-black ring-opacity-5 w-1/2 mx-3 md:w-1/3 h-96';

    const btnClass = `relative inline-flex items-center rounded-md border p-2 text-sm font-medium md:mb-3 md:last:mb-0 max-md:mr-1 max-md:last:mr-0 focus:z-10 focus:outline-none focus:ring-1
        disabled:opacity-50 disabled:cursor-not-allowed`;
    const [updateTrigger, updateResult] = useUpdateMutation();
    const updateElemento = (elemento: ElementoRMLSelezionabileRecord, selezionato: boolean) => {
        updateTrigger({...elemento, selezionato})
            .unwrap()
            .then(() => {
                if (selezionato) {
                    setElementiSelezionabili((v) => v.filter(obj => obj.codElemento !== elemento.codElemento));
                    setElementiSelezionati((v) => v.concat([elemento]));
                } else {
                    setElementiSelezionati((v) => v.filter(obj => obj.codElemento !== elemento.codElemento));
                    setElementiSelezionabili((v) => v.concat([elemento]));
                }
            })
            .catch((error: MutationError) => {
                // @ts-ignore
                const message = error.data.message;
                toastAsError(message);
            })
    }
    const Loading = () => <>{(false || isLoading) &&
        <span className="z-10 h-full flex flex-row items-center justify-center">
                     <LoadingSpinner/>
                    </span>}</>;

    const sposta = (tipo: TipoElementoRML) => { // 'ALTRO' | 'NAZIONALE' | 'TERRITORIALE' | 'AD_PERSONAM';
        for (let elemento of elementiSelezionabili) {
            if (elemento.tipo === tipo) {
                updateElemento(elemento, true);
            }
        }
    }
    const spostaDiscrezionali = () => {
        for (let elemento of elementiSelezionabili) {
            if (elemento.elementoDiscrezionale) {
                updateElemento(elemento, true);
            }
        }
    }
    const reset = () => {
        for (let elemento of elementiSelezionati) {
            updateElemento(elemento, false);
        }
        setElementiSelezionati([]);
    }

    const elementBtns = <>
        <button type="button" id="NazionBtn" className={`${btnClass} border-blue-200 bg-blue-300 hover:bg-blue-400 focus:border-blue-400 focus:ring-blue-500`}
                disabled={!data || data.length === 0}
                onClick={() => sposta('NAZIONALE')}
        >
            Nazionali&nbsp;{chevronRight}
        </button>
        <button type="button" id="TerritBtn"
                className={`${btnClass} border-yellow-200 bg-yellow-300 hover:bg-yellow-400 focus:border-yellow-400 focus:ring-yellow-500`}
                disabled={!data || data.length === 0}
                onClick={() => sposta('TERRITORIALE')}
        >
            Territoriali&nbsp;{chevronRight}
        </button>
        <button type="button" id="adPersBtn" className={`${btnClass} border-green-200 bg-green-300 hover:bg-green-400 focus:border-green-400 focus:ring-green-500`}
                disabled={!data || data.length === 0}
                onClick={() => sposta('AD_PERSONAM')}
        >
            Ad personam&nbsp;{chevronRight}
        </button>
        <button type="button" id="adAltriBtn" className={`${btnClass} border-red-200 bg-red-300 hover:bg-red-400 focus:border-red-400 focus:ring-red-500`}
                disabled={!data || data.length === 0}
                onClick={() => spostaDiscrezionali()}
        >
            Discrezionali&nbsp;{chevronRight}
        </button>
        <button type="button" id="resetBtn"
                className={`${btnClass} border-gray-200 bg-gray-300 hover:bg-gray-400 focus:border-gray-400 focus:ring-gray-500 `}
                disabled={elementiSelezionati.length === 0}
                onClick={() => reset()}>
            {chevronLeft}&nbsp;Reset
        </button>
    </>;
    return (<>
        <DndProvider backend={HTML5Backend}>
            <div className="flex flex-row items-stretch justify-evenly">
                <div className={divCardClass}>
                    <Loading/>
                    <DropZone name="elementiSelezionabili" elementi={elementiSelezionabili} type={ItemTypes.ELEMENTO_RML_UNSELECTED} accept={ItemTypes.ELEMENTO_RML_SELECTED}
                              setElementiSelezionabili={setElementiSelezionabili}
                              setElementiSelezionati={setElementiSelezionati}
                              onDrop={handleDrop}
                    />
                </div>

                <div className="flex flex-col self-center max-md:hidden">
                    {elementBtns}
                </div>

                <div className={divCardClass}>
                    <Loading/>
                    <DropZone name="elementiSelezionati" elementi={elementiSelezionati} type={ItemTypes.ELEMENTO_RML_SELECTED} accept={ItemTypes.ELEMENTO_RML_UNSELECTED}
                              setElementiSelezionabili={setElementiSelezionati}
                              setElementiSelezionati={setElementiSelezionabili}
                              onDrop={handleDrop}
                    />
                </div>
            </div>

            <div className="flex flex-row self-center mt-5 max-md:justify-evenly md:hidden">
                {elementBtns}
            </div>

        </DndProvider>
        {children}
        {onApply && <div className="mt-5 pt-5 w-full border-t border-gray-200">
            <div className="flex flex-row justify-end">
                {children && onResetFilter && <button type="button"
                                                      className="mr-2 inline-flex justify-center p-1.5 sm:p-2 md:py-2 md:px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600
                                                                    max-lg:mb-1
                                                                    hover:bg-blue-700
                                                                    focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
                                                                    disabled:opacity-50"
                                                      onClick={() => {
                                                          onResetFilter();
                                                      }}>
                    Reset filtro
                </button>}
                <button onClick={onApply}
                        className="btnPrimary"
                        disabled={elementiSelezionati.length === 0}
                >
                    Applica selezione
                </button>
            </div>
        </div>
        }
    </>)
}
export default AreaSelezioneElementiRML;

const chevronLeft = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-4 h-4">
    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5"/>
</svg>;

const chevronRight = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-4 h-4">
    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5"/>
</svg>;